/* eslint-disable max-lines */
import { RSAA } from 'redux-api-middleware';
import moment from 'moment';
import Html2Canvas from 'html2canvas';
import {
  SCREEN_SHOT_MIME_TYPE,
  SCREEN_SHOT_QUALITY,
  API_STRING_FIELD_MAX_LENGTH,
  NAVIGATE_TO_BAA,
  DEFAULT_EMAIL_ID,
  TRADING_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE,
  NAVIGATE_TO_EXIT,
  ROUTE_ABOUT_YOUR_BUSINESS,
  ROUTE_REVIEW_PAGE,
  NAVIGATION_BACK,
  ROUTE_GDPR
} from '../../utils/constants';
import {
  getNextRoutePath,
  redirectToConditionalRoute,
  getCurrentPage
} from '../../routes/routUtils/routingUtils';
import { updateCase } from '../../infrastructure/cases';
import { getPayload, getEvidenceUrl } from '../../utils';
import { getAddressByType, getRegisterAddress, getTradingName } from './addressPayload';
import { BUSINESS_FINANCE_PAGE_KEY } from '../../routes/routUtils/routingConstants';
import { setCurrentPage, getBackRoute } from '../../routes/routUtils/routingUtils';
import { GDPR_PAGE_KEY } from '../../routes/routUtils/routingConstants';

export const SOLE_TRADER = 'sole trader';

//TODOxCYBG - Need to revisit to copy constants into utils/constants file
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS';
export const SUBMIT_FORM_FAILED = 'SUBMIT_FORM_FAILED';
export const SAVE_EVIDENCE_TYPE_FORM = 'SAVE_EVIDENCE_TYPE_FORM';
export const SUBMIT_IMAGE_SERVICE_CALL = 'SUBMIT_IMAGE_SERVICE_CALL';
export const SAVE_FINANCE_FORM = 'SAVE_FINANCE_FORM';
export const SAVE_BUSINESS_TYPE_FORM = 'SAVE_BUSINESS_TYPE_FORM';
export const SAVE_BUSINESS_DETAILS_ALL_FORM = 'SAVE_BUSINESS_DETAILS_ALL_FORM';
export const SAVE_BUSINESS_CONTACT_DETAILS_FORM = 'SAVE_BUSINESS_CONTACT_DETAILS_FORM';
export const SAVE_BUSINESS_FORM = 'SAVE_BUSINESS_FORM';
export const SAVE_BUSINESS_FINANCE_FORM = 'SAVE_BUSINESS_FINANCE_FORM';
export const SAVE_BUSINESS_FINANCE_UPDATE_FORM = 'SAVE_BUSINESS_FINANCE_UPDATE_FORM';
export const SAVE_BUSINESS_FINANCE_TAX_UPDATE_FORM = 'SAVE_BUSINESS_FINANCE_TAX_UPDATE_FORM';
export const SAVE_GDPR_FORM = 'SAVE_GDPR_FORM';
export const GET_CUSTOMER_DATA = 'GET_CUSTOMER_DATA';
export const REDIRECT_GDPR_PAGE = 'REDIRECT_GDPR_PAGE';
export const REDIRECT_UPDATE = 'REDIRECT_UPDATE';
export const REDIRECT_CONTACT_DETAILS = 'REDIRECT_CONTACT_DETAILS';
export const REDIRECT_ABOUT_PAGE = 'REDIRECT_ABOUT_PAGE';
export const UPDATE_ACCORDIAN_DETAILS = 'UPDATE_ACCORDIAN_DETAILS';
export const SUBMIT_EVIDENCE_FORM = 'SUBMIT_EVIDENCE_FORM';
export const SUBMIT_EVIDENCE_SUCCESS = 'SUBMIT_EVIDENCE_SUCCESS';
export const SUBMIT_EVIDENCE_FAILED = 'SUBMIT_EVIDENCE_FAILED';
export const SUBMIT_GDPR_FORM = 'SUBMIT_GDPR_FORM';
export const SUBMIT_GDPR_FORM_SUCCESS = 'SUBMIT_GDPR_FORM_SUCCESS';
export const SUBMIT_GDPR_FORM_FAILED = 'SUBMIT_GDPR_FORM_FAILED';
export const UPDATE_FORM = 'UPDATE_FORM';
export const UPDATE_FORM_SUCCESS = 'UPDATE_FORM_SUCCESS';
export const UPDATE_FORM_FAILED = 'UPDATE_FORM_FAILED';
export const UPDATE_ACCORDION_FORM = 'UPDATE_ACCORDION_FORM';
export const UPDATE_ACCORDION_FORM_SUCCESS = 'UPDATE_ACCORDION_FORM_SUCCESS';
export const UPDATE_ACCORDION_FORM_FAILED = 'UPDATE_ACCORDION_FORM_FAILED';
export const ERROR_PAGE = 'ERROR_PAGE';
export const REDIRECT_TO_GDPR_SCREEN = 'REDIRECT_TO_GDPR_SCREEN';
export const STORE_BUSINES_TYPE = 'STORE_BUSINES_TYPE';
const REDIRECT_TO_PAGE = 'REDIRECT_TO_PAGE';
export const ON_CANCEL_EDIT_CLICK = 'cancel_edit_click';
export const TOGGLE_GDPR_MODAL = 'TOGGLE_GDPR_MODAL';

const LIMITED_COMPANY = 'Limited company';
const MAX__UPDATE_TRIES = 5;
const UPDATE_CALL_DELAY = 5000;
let noOfUpdateTries = 1;
const MAX_CHAR_LIMIT = 40;
export const submitForm = (actionData) => ({
  [RSAA]: {
    endpoint: ':api_paas_url/banks/:bank_id/customers/nonpersonal',
    method: 'POST',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: (state) => getCreateBody(state, actionData),
    types: [
      {
        type: SUBMIT_FORM,
        meta: { loading: true }
      },
      {
        type: SUBMIT_FORM_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, _state, res) => ({
          nextAction: updateForm('', res.json.id, getNextRequiredAction),
          loading: false
        })
      },
      {
        type: SUBMIT_FORM_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

const getNextRequiredAction = (state) => {
  const businessType = state.dataCapture.get('businessTypeField');
  return businessType && businessType.toLowerCase() === SOLE_TRADER
    ? { nextAction: redirectToContactDetails(), loading: false }
    : { nextAction: redirectToTaxDetails(), loading: false };
};

const updateAgain = (id, callbackAction) => (dispatch) => {
  noOfUpdateTries = noOfUpdateTries + 1;
  return noOfUpdateTries < MAX__UPDATE_TRIES && callbackAction
    ? setTimeout(() => {
        dispatch(updateForm('', id, callbackAction));
      }, UPDATE_CALL_DELAY)
    : dispatch(technicalErrorPage());
};
export const redirectToRoutePath = (path) => ({
  type: 'next_route',
  path: path
});
export const redirectToBackScreen = (pathName, isGDPRModel) => (dispatch) => {
  const defaultPathName = [ROUTE_ABOUT_YOUR_BUSINESS, ROUTE_REVIEW_PAGE];
  if (pathName === ROUTE_GDPR && !isGDPRModel) {
    setCurrentPage(GDPR_PAGE_KEY);
    dispatch(toggleGDPRModal(true));
    return;
  }
  if (defaultPathName.includes(pathName)) {
    return dispatch(redirectToBusinessAccount(NAVIGATION_BACK));
  }
  return dispatch(redirectToRoutePath(getBackRoute()));
};
export const toggleGDPRModal = (isOpen) => ({
  type: TOGGLE_GDPR_MODAL,
  isOpen
});
export const submitImageServiceCall = (image, caseType, caseId) => ({
  [RSAA]: {
    endpoint: getEvidenceUrl(caseType, caseId),
    method: 'POST',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: () => createEvidenceRequestBody(image),
    types: [
      {
        type: SUBMIT_EVIDENCE_FORM,
        meta: { loading: true }
      },
      {
        type: SUBMIT_EVIDENCE_SUCCESS,
        meta: () => {
          return { nextAction: redirectToBusinessAccount(), loading: false };
        }
      },
      {
        type: SUBMIT_EVIDENCE_FAILED,
        meta: () => {
          return { nextAction: redirectToBusinessAccount(), loading: false };
        }
      }
    ]
  }
});

/**
 * This will take screenshot by using Html2Canvas
 */
const takeScreenshot = (caseType, caseId) => {
  let rootEl = document.getElementById('rootEl');
  rootEl = rootEl ? rootEl : document.body;
  return (dispatch) =>
    Html2Canvas(rootEl).then((canvas) => {
      const screenshot = canvas.toDataURL(SCREEN_SHOT_MIME_TYPE, SCREEN_SHOT_QUALITY);
      let imageStrValue = screenshot;
      const parts = [];

      if (typeof imageStrValue !== 'string' || imageStrValue.length === 0) {
        return parts;
      }
      const numParts = Math.ceil(imageStrValue.length / API_STRING_FIELD_MAX_LENGTH);
      for (let i = 0; i < numParts; i++) {
        parts.push(imageStrValue.substr(0, API_STRING_FIELD_MAX_LENGTH));
        imageStrValue = imageStrValue.substr(API_STRING_FIELD_MAX_LENGTH);
      }
      dispatch(sendImageServiceCall(parts, caseType, caseId));
    });
};

/**
 * This will create request body to send image to Service
 * @param {*} screenImage
 */
const createEvidenceRequestBody = (screenImage) => {
  const requestData = {
    context: 'capture',
    image: {
      data: screenImage,
      mime_type: SCREEN_SHOT_MIME_TYPE
    },
    capture_timestamp: moment().format()
  };
  return JSON.stringify(requestData);
};

export const submitGDPRForm = (actionData, custId, caseId, caseType) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers/${custId}/marketconsent`,
    method: 'PUT',
    headers: {
      'x-bpi-version': '0.8.0'
    },
    body: (_state) =>
      JSON.stringify({
        marketing_preferences: [
          {
            type: 'VOICE',
            value: getPayloadValues(actionData.gdprPhoneField)
          },
          {
            type: 'POST',
            value: getPayloadValues(actionData.gdprPostField)
          },
          {
            type: 'EMAIL',
            value: getPayloadValues(actionData.gdprEmailField)
          },
          {
            type: 'MESSAGING',
            value: getPayloadValues(actionData.gdprMessagingField)
          },
          {
            type: 'INTERNET_BANKING',
            value: getPayloadValues(actionData.gdprInternetField)
          }
        ]
      }),
    types: [
      {
        type: SUBMIT_GDPR_FORM,
        meta: { loading: true }
      },
      {
        type: SUBMIT_GDPR_FORM_SUCCESS,
        meta: () => ({ nextAction: submitEvidence(caseType, caseId), loading: true })
      },
      {
        type: SUBMIT_GDPR_FORM_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

export const updateForm = (actionData, createId, getNextRequiredAction, isIncludeAll) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers/nonpersonal/${createId}`,
    method: 'PUT',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: (state) => getUpdateBody(state, actionData, isIncludeAll),
    types: [
      {
        type: UPDATE_FORM,
        meta: { loading: true }
      },
      {
        type: UPDATE_FORM_SUCCESS,
        meta: () => ({
          nextAction: processUpdateFormSuccess(getNextRequiredAction),
          loading: false
        })
      },
      {
        type: UPDATE_FORM_FAILED,
        meta: () => {
          return { nextAction: updateAgain(createId, getNextRequiredAction) };
        }
      }
    ]
  }
});

const processUpdateFormSuccess = (getNextRequiredAction) => {
  noOfUpdateTries = 1;
  return getNextRequiredAction && getCurrentPage() === BUSINESS_FINANCE_PAGE_KEY
    ? updateCase(getNextRequiredAction)
    : getNextRequiredAction
    ? getNextRequiredAction()
    : redirectTOGdprPage();
};

export const updateAccordion = (createId) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers/nonpersonal/${createId}`,
    method: 'PUT',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: (state) => getUpdateBody(state, '', true),
    types: [
      {
        type: UPDATE_ACCORDION_FORM,
        meta: { loading: true }
      },
      {
        type: UPDATE_ACCORDION_FORM_SUCCESS,
        meta: {
          nextAction: redirectToBusinessAccount(),
          loading: false
        }
      },
      {
        type: UPDATE_ACCORDION_FORM_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

//TODOxCYBG - Need to revisit and change all function to Arrow functions

function getIdentityInfo(taxList) {
  if (taxList) {
    const taxInfo = taxList.map((data) => {
      const taxData = data.toJS();
      return { country_of_residency: taxData.countryField, number: taxData.taxNumber };
    });
    return taxInfo;
  }
  return [];
}

function getTaxEntityType(confirmAllTaxObligation) {
  const confirmObligation =
    confirmAllTaxObligation === 'Yes' ? 'Non-Financial Institution' : 'Please Investigate';
  return confirmObligation;
}

function getPayloadValues(value) {
  return value === 'Yes' ? 'Y' : 'N';
}

function incorporationDate(dateValue = {}) {
  const { dateField, monthField, yearField } = dateValue;
  return `${yearField}-${monthField}-${dateField}`;
}

function getBody(state, actionData) {
  const request = {
    customer_type: 'NONPERSONAL',
    business_details: {
      type: getBusinessType(state),
      trading_name: state.dataCapture.get('tradingName'),
      begin_trading_date: actionData
        ? incorporationDate(actionData.beginTrading)
        : incorporationDate(state.dataCapture.get('beginTrading').toJS()),
      industry_type: state.dataCapture.get('industryType'),
      industry_description: state.dataCapture.get('industryDescription'),
      business_activity_type: state.dataCapture.get('activityTypes'),
      need_business_licence:
        state.dataCapture.get('needLicence') === 'No'
          ? 'No'
          : state.dataCapture.get('typeOfLicense'),
      no_of_employees: state.dataCapture.get('numberOfPeople')
    }
  };
  const addresses = [];
  addresses.push(getAddressByType(state, TRADING_ADDRESS_TYPE));
  addresses.push(getAddressByType(state, MAILING_ADDRESS_TYPE));
  request.business_details.addresses = addresses;
  return request;
}

const getBusinessType = (state) => {
  const type = state.dataCapture.get('businessTypeField');
  if (type && type.toLowerCase() === SOLE_TRADER) {
    return type;
  }
  return LIMITED_COMPANY;
};

function getRegisterCompanyPayload(state) {
  const businessType = state.dataCapture.get('businessTypeField');
  if (businessType && businessType.toLowerCase() !== SOLE_TRADER) {
    const { dataCapture } = state;

    return {
      registered_company: Object.assign(
        {},
        {
          name: getRegisteredCompany_Name(state),
          number: dataCapture.get('registeredNumber'),
          incorporation_date: incorporationDate(dataCapture.get('incorporationDate').toJS())
        },
        getRegisterAddress(state)
      )
    };
  }
  return {
    registered_company: {
      name: getTradingName(state)
    }
  };
}

const getRegisteredCompany_Name = (state) => {
  const reg_name = `${state.dataCapture.get('registeredName')} t/a ${state.dataCapture.get(
    'tradingName'
  )}`;
  if (state.dataCapture.get('tradingName') && reg_name && reg_name.length <= MAX_CHAR_LIMIT) {
    return reg_name;
  }
  return state.dataCapture.get('registeredName');
};

function createBodyData(actionData) {
  const request = {
    financial_info: {
      cost_to_start_business: actionData.costToStartBusiness,
      annual_sales_turnover: `${actionData.annualSales}`,
      business_startup_funds_source: actionData.fundsToStartBusiness
    }
  };
  return request;
}

function updateBody(state, actionData, isIncludeAll) {
  const request = {
    financial_info: {
      cost_to_start_business: state.dataCapture.get('costToStartBusiness'),
      annual_sales_turnover: `${state.dataCapture.get('annualSales')}`,
      business_startup_funds_source: state.dataCapture.get('fundsToStartBusiness')
    },
    account_with_other_bank: getPayloadValues(state.dataCapture.get('anotherBankAccount'))
  };
  const contactDetails =
    actionData || isIncludeAll
      ? {
          contact_details: {
            phone: {
              work: actionData ? actionData.businessNumber : state.dataCapture.get('businessNumber')
            },
            email: actionData ? actionData.emailAddress : state.dataCapture.get('emailAddress'),
            preferred_contact: actionData
              ? actionData.preferredContactMethod
              : state.dataCapture.get('preferredContactMethod')
          }
        }
      : '';
  return Object.assign({}, request, contactDetails);
}

function switchBank(state) {
  if (state.dataCapture.get('switchingBankAccount') === 'Yes') {
    const request = {
      switch_account: {
        account_number: state.dataCapture.get('accountNumber'),
        sort_code: sortcodeCombine(state.dataCapture.get('sortCode').toJS())
      }
    };
    return request;
  }
  return '';
}

function sortcodeCombine(sortcode) {
  return `${sortcode.sortField1}${sortcode.sortField2}${sortcode.sortField3}`;
}

function getCreateBody(state, actionData) {
  const commonData = getBody(state, actionData);
  const createData = createBodyData(actionData);
  const registerData = getRegisterCompanyPayload(state);
  commonData.business_details = Object.assign({}, commonData.business_details, createData);
  commonData.business_details = Object.assign({}, commonData.business_details, registerData);
  commonData.business_details = Object.assign(
    {},
    commonData.business_details,
    getContactDetails(state)
  );
  return JSON.stringify(commonData);
}

function getUpdateBody(state, actionData, isIncludeAll) {
  const commonData = getBody(state);
  const updateData = updateBody(state, actionData, isIncludeAll);
  const registerData = getRegisterCompanyPayload(state);
  const switchData = switchBank(state);
  commonData.business_details = Object.assign({}, commonData.business_details, registerData);
  commonData.business_details = Object.assign(
    {},
    commonData.business_details,
    updateData,
    registerData,
    switchData
  );
  const businessType = state.dataCapture.get('businessTypeField');
  if (businessType && businessType.toLowerCase() !== SOLE_TRADER) {
    commonData.business_details.financial_info = Object.assign(
      {},
      commonData.business_details.financial_info,
      actionData || isIncludeAll ? taxDetails(state) : ''
    );
  }
  return JSON.stringify(commonData);
}

function taxDetails(state) {
  return {
    tax_info: {
      identification_info: getIdentityInfo(state.dataCapture.get('taxList')),
      uk_taxpayer_only: getPayloadValues(state.dataCapture.get('hasTaxObligation')),
      tax_entity_type: getTaxEntityType(state.dataCapture.get('incomeFromBusiness'))
    }
  };
}

const getContactDetails = (state) => {
  let caseData = state.cases.get('caseData');
  caseData = caseData ? caseData.toJS() : '';
  const email = caseData ? caseData.applicant.contact_details.email : '';
  return {
    contact_details: {
      email: email || DEFAULT_EMAIL_ID
    }
  };
};

export const updateAccordionForm = (businessId) => ({
  type: UPDATE_ACCORDIAN_DETAILS,
  meta: {
    nextAction: updateAccordion(businessId)
  }
});

export const saveBusinessTypeForm = (data) => ({
  type: STORE_BUSINES_TYPE,
  data,
  path: '/aboutBusiness'
});

export const saveBusinessForm = (data) => ({
  type: SAVE_BUSINESS_FORM,
  data,
  path: getNextRoutePath()
});

export const saveBusinessFinanceForm = (data) => ({
  type: SAVE_BUSINESS_FINANCE_FORM,
  data,
  meta: {
    nextAction: submitForm(data, redirectToContactDetails)
  }
});

export const saveBusinessUpdateForm = (data) => ({
  type: SAVE_BUSINESS_FINANCE_UPDATE_FORM,
  data,
  path: getNextRoutePath()
});

export const saveBusinessTaxUpdateForm = (data) => ({
  type: SAVE_BUSINESS_FINANCE_TAX_UPDATE_FORM,
  data,
  path: getNextRoutePath()
});

export const redirectToExit = () => ({
  type: NAVIGATE_TO_EXIT,
  redirect: {
    to: NAVIGATE_TO_EXIT
  }
});

export const redirectToContactDetails = () => ({
  type: REDIRECT_CONTACT_DETAILS,
  path: getNextRoutePath()
});

export const redirectToTaxDetails = () => ({
  type: REDIRECT_CONTACT_DETAILS,
  path: getNextRoutePath()
});

export const redirectToAllDetails = () => ({
  type: REDIRECT_CONTACT_DETAILS,
  path: getNextRoutePath()
});

export const redirectToGDPRScreen = () => ({
  type: REDIRECT_TO_GDPR_SCREEN,
  path: getNextRoutePath()
});

export const redirectToBusinessAccount = (navigation) => ({
  type: NAVIGATE_TO_BAA,
  redirect: {
    to: NAVIGATE_TO_BAA,
    navigation: navigation
  }
});

export const saveFinanceForm = (data, businessId) => ({
  type: SAVE_FINANCE_FORM,
  data,
  meta: {
    nextAction: updateForm(data, businessId, redirectToContactDetails, true)
  }
});

export const saveGDPRForm = (data, custId, caseId, caseType) => ({
  type: SAVE_GDPR_FORM,
  data,
  custId,
  meta: {
    nextAction: submitGDPRForm(data, custId, caseId, caseType)
  }
});

export const saveBusinessTypeChanges = (data) => ({
  type: SAVE_BUSINESS_TYPE_FORM,
  data
});

export const technicalErrorPage = (data) => ({
  type: ERROR_PAGE,
  data,
  path: '/technicalError',
  meta: {
    loading: false
  }
});

export const saveBusinessFinanceChanges = (data) => ({
  type: SAVE_BUSINESS_FINANCE_FORM,
  data
});

export const saveAboutBusinessChanges = (data) => ({
  type: SAVE_BUSINESS_FORM,
  data
});

export const saveTaxFinanceChanges = (data) => ({
  type: SAVE_FINANCE_FORM,
  data
});

export const saveBusinessContactDetailsForm = (data, businessId) => ({
  type: SAVE_BUSINESS_CONTACT_DETAILS_FORM,
  data,
  meta: {
    nextAction: updateForm(data, businessId)
  }
});

export const saveContactChanges = (data) => ({
  type: SAVE_BUSINESS_CONTACT_DETAILS_FORM,
  data
});

export const saveBusinessDetailsAllForm = (data) => ({
  type: SAVE_BUSINESS_DETAILS_ALL_FORM,
  data,
  meta: {
    nextAction: updateAccordionForm()
  }
});

export const getCustomerData = (data) => ({
  type: GET_CUSTOMER_DATA,
  data,
  path: getNextRoutePath()
});

export const redirectTOGdprPage = () => ({
  type: REDIRECT_GDPR_PAGE,
  path: getNextRoutePath()
});

export const redirectToAboutPage = () => ({
  type: REDIRECT_ABOUT_PAGE,
  path: '/about'
});

export const redirectToNextRout = () => ({
  type: 'next_route',
  meta: { nextAction: redirectToConditionalRoute() }
});

export const submitEvidence = (caseType, caseId) => ({
  type: SAVE_EVIDENCE_TYPE_FORM,
  meta: {
    nextAction: takeScreenshot(caseType, caseId)
  }
});

export const sendImageServiceCall = (data, caseType, caseId) => ({
  type: SUBMIT_IMAGE_SERVICE_CALL,
  data,
  meta: {
    nextAction: submitImageServiceCall(data, caseType, caseId)
  }
});

export const onAddressSelection = (type, data) => ({
  type: `${type}_ADDRESS_SELECTION`,
  data: data
});

export const SAVE_BUSINESS_FORM_VALUES = 'BUSINESS_FORM_VALUES';

export const saveAboutYourFormValues = (data) => ({
  type: SAVE_BUSINESS_FORM_VALUES,
  data: data
});

export const onAddressEditClick = (type) => ({
  type: `${type}ADDRESS_EDIT_CLICK`,
  data: false
});

export const redirectToPage = (url) => ({
  type: REDIRECT_TO_PAGE,
  path: url
});

export const onCancelEditClick = () => ({
  type: ON_CANCEL_EDIT_CLICK
});
